import * as React from "react";
import { Container, Menu, Icon, Label } from "semantic-ui-react";

// This menu was based on
// https://github.com/fabien0102/gatsby-starter
export const HeaderMenu = ({ items, pathname, Link, inverted, toggle, numberOfCartItem }) => {

  if (numberOfCartItem===0) numberOfCartItem=" "

  return (
    <Container>
      <Menu size="large" pointing secondary inverted={inverted}>
        <Menu.Item as="a" className="mobile only" icon="sidebar" onClick={ toggle } />
        {items.map((item) => {
          let active = false
          if (pathname)
            active = (item.exact) ? pathname === item.path : pathname.startsWith(item.path);
          return <Menu.Item
            as={Link}
            className="mobile hidden"
            name={item.name}
            to={item.path}
            key={item.path}
            active={active}
          />;
        })}

        <Menu.Menu position='right'>
          <Menu.Item
            as={Link}
            active={ pathname ? pathname.startsWith("/cart") : false}
            className="mobile hidden"
            to="/cart/"
          >
            <Label>
              <Icon name='shopping cart' />
              {numberOfCartItem}
            </Label>

          </Menu.Item>
        </Menu.Menu>

      </Menu>

    </Container>
  )
}

 //          onClick={this.handleItemClick}

export default HeaderMenu;
